import { render } from "./MorgueManagement.vue?vue&type=template&id=dcf3be10&scoped=true"
import script from "./MorgueManagement.vue?vue&type=script&lang=js"
export * from "./MorgueManagement.vue?vue&type=script&lang=js"

import "./MorgueManagement.vue?vue&type=style&index=0&id=dcf3be10&lang=css"
import "./MorgueManagement.vue?vue&type=style&index=1&id=dcf3be10&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcf3be10"]])

export default __exports__